<script setup>
import { useChooserFormStore } from '@/store/forms/chooser';
import { ref } from 'vue';

const formStore = useChooserFormStore();

let clickForDebug = ref(1);

function increment() {
    clickForDebug.value++;
    if (clickForDebug.value === 16) {
        formStore.$patch({
            debug: true,
        });
    }
}
</script>

<template>
    <h1 class="text-2xl mb-2 uppercase" @click="increment()">
        <slot />
    </h1>
</template>
